import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { post } from '../../util/api';

const Register = (props) => {
  const [email, setEmail] = useState('jenny.rosen@example.com');
  const [customer, setCustomer] = useState(null);

  const handleSubmit = async (e) => {
    // e.preventDefault();
    // const {customer} = await post('/api/create-customer', {
     
    //     email: email,
  
    // })

    // setCustomer(customer);
  };

  if(customer) {
    return <Redirect to={{pathname: '/prices'}} />
  }

  return (
    <main>
      <h1>Sample Photo Service</h1>

      <p>
        Unlimited photo hosting, and more. Cancel anytime.
      </p>

      <form onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="text"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required />
        </label>

        <button type="submit">
          Register
        </button>
      </form>
    </main>
  );
}

export default Register;
